module.exports = "/_next/static/images/ThirdIntroduceImg-9ce3eb51874a5da3c7ceef1cefa2d1dc.png";